import { useSelector } from 'react-redux';

import { isScrollingDisabled } from '../../ducks/ui.duck';

export const useIsScrollingDisabled = () => {
  return useSelector(isScrollingDisabled);
};
